// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class EITExportResource extends Resource {
    basePath: string = 'networks/export';

    startExport() {
        return this.client._request(`${this._getBasePath()}`, 'POST');
    }

    list(query: Object): Promise<Object> {
        return this.client._request(`${this._getBasePath()}s`, 'GET', query).then((response) => response.data);
    }
}
